"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderWrapper = ({ children = null, subHeader = null }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("header", { className: "shadow-header bg-header-background border-b border-header-border z-40" },
        react_1.default.createElement("nav", { className: "max-w-page mx-auto px-4 sm:px-6 lg:px-16" },
            react_1.default.createElement("div", { className: "flex justify-between items-center h-16 md:h-20 " }, children))),
    subHeader && (react_1.default.createElement("div", { className: "bg-header-background shadow-header z-30" },
        react_1.default.createElement("div", { className: "max-w-page mx-auto py-3 px-4 sm:px-6 lg:px-16" }, subHeader)))));
exports.default = HeaderWrapper;
//# sourceMappingURL=HeaderWrapper.js.map